import type CustomPayment from '~~/constants/customPayment';
import { getLastPayment } from '~~/helpers/cart/getLastPayment';
import type { Order } from '~~/types/commercetools';

export default function (order: Order): Maybe<ValueOf<typeof CustomPayment>> {

  return getLastPayment(order)?.paymentMethodInfo?.paymentInterface;

}
